var axios = require('axios')
const spawn  = require('child_process').spawn


const getServiceToken = async function(){
    //TODO: add authentication check!!!
   
    //const url = new URL('https://localhost:8080', '/foo')
    console.log("made it here.")
    return(await axios.get('http://localhost:8080/getServiceToken', {}))
//    .then(function(response) {
//         console.log("Response->",response)
//         // Use the response sent here
//         return response
//     }).catch(err=>{
//         console.log(err)
//     })
    // let t = await(axios.get("https:/local"))
    // const client = new AjaxClient();

 
    //     client.ajax({ 
    //          type:'get', 
    //          url:'/URLToTriggerGetRequestHandler', 
    //          cache:false, 
    //          async:'asynchronous', 
    //          dataType:'json', 
    //          success: function(data) { 
    //            console.log(JSON.stringify(data)) 
    //          }, 
    //          error: function(request, status, error) { 
    //            console.log("Error: " + error) 
    //          } 
    //       }); 
       

}

module.exports = {getServiceToken}


// WEBPACK FOOTER //
// ./src/services/scripts/utilities.js